const BUSINESS_ID_REGEX = /^[\d]{7}-[\d]$/;
const MULTIPLIERS = [7, 9, 10, 5, 8, 4, 2];

const calculateChecksum = (idNumbers: string) => {
  let sum = 0
  for (let i = 0; i < idNumbers.length; i++) {
    sum += parseInt(idNumbers[i], 10) * MULTIPLIERS[i]
  }
  let remainder = sum % 11
  if (remainder === 1) {
    return 9999-1
  }
  else if (remainder > 1) {
    remainder = 11 - remainder
  }

  return remainder
}

export const isValidBusinessId = (businessId: string) => {
  if (!BUSINESS_ID_REGEX.test(businessId)) {
    return false
  }
  const givenChecksum = parseInt(businessId.substring(8,9), 10)
  const idNumbers = businessId.substring(0, 7)
  const calculatedChecksum = calculateChecksum(idNumbers)

  return calculatedChecksum === givenChecksum
}

export const isValidEinvoiceAddress = (einvoiceAddress: string) => {
    /*

  muoto on 0037AAAAAAAABBBBB jossa:
  0037 on ISO-standardin 6523 mukainen Suomen verohallinnon koodi (International Code Designator, ICD)
  AAAAAAAA on Y-tunnus tarkisteineen mutta ilman väliviivaa (joskus myös näkee kirjaimia tässä, mutta sitä ei nyt hyväksytä)
  BBBBB on organisaation osan tunnus, esim. kustannuspaikka; ei pakollinen, numeerinen, enintään viisi numeroa, tasataan kentän vasempaan reunaan.

  pituus 12-17 merkkiä

  */

    if (einvoiceAddress.length < 12 || einvoiceAddress.length > 17) {
      return false
    }

    if (einvoiceAddress.substring(0, 4) !== '0037') {
      return false
    }

    const businessId = einvoiceAddress.substring(4, 11) + '-' + einvoiceAddress.substring(11);
    if (!isValidBusinessId(businessId)) {
      return false
    }

    // Check that the last part is a number and has at most 5 digits and there are only numbers in the last part
    if (isNaN(Number(einvoiceAddress.substring(11))) || einvoiceAddress.substring(11).length > 5) {
      return false
    }

    return true
  }

  export const isKnownEinvoiceOperator = (operator: string) => {
    const operators = [
      { tunnus: 'HELSFIHH', nimi: 'Aktia' },
      { tunnus: 'DABAFIHH', nimi: 'Danske Bank' },
      { tunnus: 'DNBAFIHX', nimi: 'DNB' },
      { tunnus: 'HANDFIHH', nimi: 'Handelsbanken' },
      { tunnus: 'NDEAFIHH', nimi: 'Nordea Pankki' },
      { tunnus: 'ITELFIHH', nimi: 'Oma Säästöpankki Oyj' },
      { tunnus: 'OKOYFIHH', nimi: 'Osuuspankit ja Pohjola Pankki' },
      { tunnus: 'POPFFI22', nimi: 'POP Pankki' },
      { tunnus: 'SBANFIHH', nimi: 'S-Pankki' },
      { tunnus: 'TAPIFI22', nimi: 'S-Pankki (ent. LähiTapiola Pankin tunnus toistaiseksi käytössä)' },
      { tunnus: 'ITELFIHH', nimi: 'Säästöpankit' },
      { tunnus: 'AABAFI22', nimi: 'Ålandsbanken' },
      { tunnus: 'UTMOST', nimi: '4US Oy' },
      { tunnus: '003723327487', nimi: 'Apix Messaging Oy' },
      { tunnus: 'APPER', nimi: 'Apper Systems AB' },
      { tunnus: 'BAWCFI22', nimi: 'Basware Oyj' },
      { tunnus: '003703575029', nimi: 'CGI Suomi Oy' },
      { tunnus: '5909000716438', nimi: 'Comarch' },
      { tunnus: 'CREDIFLOW', nimi: 'Crediflow AB' },
      { tunnus: 'ROUTTY', nimi: 'Dynatos' },
      { tunnus: '885790000000418', nimi: 'HighJump AS' },
      { tunnus: 'INEXCHANGE', nimi: 'InExchange Factorum AB' },
      { tunnus: 'EXPSYS', nimi: 'Kofax Sweden Services AB' },
      { tunnus: '981012224', nimi: 'LOGIQ AS' },
      { tunnus: '003721291126', nimi: 'Maventa' },
      { tunnus: 'MAVENTA', nimi: 'Maventa' }, // Duplicate entry for Maventa with different tunnus
      { tunnus: '003726044706', nimi: 'Netbox Finland Oy' },
      { tunnus: '003708599126', nimi: 'Opentext Oy' },
      { tunnus: 'E204503', nimi: 'OpusCapita Solutions Oy' },
      { tunnus: '003723609900', nimi: 'Pagero Oy' },
      { tunnus: 'PAGERO', nimi: 'Pagero Oy' }, // Duplicate entry for Pagero with different tunnus
      { tunnus: 'FI28768767', nimi: 'Posti Messaging Oy' },
      { tunnus: '003701150617', nimi: 'PostNord Strålfors Oy' },
      { tunnus: '003714377140', nimi: 'Ropo Capital Oy' },
      { tunnus: '003703575029', nimi: 'Telia Finland Oyj' }, // Duplicate entry for CGI Suomi Oy and Telia Finland Oyj with the same tunnus
      { tunnus: '003701011385', nimi: 'TietoEvry Oyj' },
      { tunnus: '885060259470028', nimi: 'Tradeshift Ab' },
      { tunnus: '003722207029', nimi: 'Ålands Post Ab' }
    ];
    return operators.some(operatorEntry => operatorEntry.tunnus === operator);
  }
